module.exports = __webpack_public_path__ + "img/CT.Bridges.Superstructure.Steel_Box_Girder_and_Deck_60m.Steel.e09817e3.png";